<template>
    <BaseSpinner v-if="pending" />
    <BaseSection
        v-else
        data-width="bleed"
    >
        <BaseCard
            v-for="(event, index) in data.entries"
            :key="index"
            :card-item="event"
            type="event"
        />
        <BasePaginator
            :current-page="currentPage"
            :total-pages="totalPages"
            :query-param="queryParam"
            @update:current-page="updatePage($event)"
        />
    </BaseSection>
</template>

<script setup>
import { formatISO } from 'date-fns';
import getPages from '~/graphql/queries/getPages.graphql';

const { variables: defaultVariables } = useCraftGraphql();

const { currentPage, offset, queryParam, limit } = usePaginator(20);

const variables = computed(() => {
    const now = formatISO(Date.now(), { representation: 'date' });

    return {
        ...defaultVariables,
        uri: undefined, // We don't need the URI for this query
        section: 'events',
        order: 'plainDate ASC',
        limit: limit.value,
        offset: offset.value,
        now: ['or', `>= ${now}`, null]
    };
});

const { data, pending } = await useLazyAsyncQuery({
    query: getPages,
    variables
});

const { totalPages} = usePaginated(data,limit);

const updatePage = (page) => {
    currentPage.value = page;

    nextTick(() => {
        window.scrollTo(0, 0);
        focus.value.focus();
    });
};
</script>
